import { render, staticRenderFns } from "./PagedReaderSpread.vue?vue&type=template&id=6ad04b5e&scoped=true&"
import script from "./PagedReaderSpread.vue?vue&type=script&lang=ts&"
export * from "./PagedReaderSpread.vue?vue&type=script&lang=ts&"
import style0 from "./PagedReaderSpread.vue?vue&type=style&index=0&id=6ad04b5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad04b5e",
  null
  
)

export default component.exports